import { buildAuthLoginUri } from '~/utils/buildAuthLoginUri';
import type { RouteMiddleware } from '#app';
import { VISIBILITY_OPTIONS } from '~/utils/entry/isVisible';

export const authMiddleware: RouteMiddleware = async (to) => {
  const { ssrContext } = useNuxtApp();
  const slug = ensureArray(to.params.slug).filter(Boolean).join('/');
  const { loggedIn } = useShopAuth();

  if (ssrContext) {
    return;
  }

  const getPageVisibilityForSlug = await useRestrictedProtectedSlugs();
  if (
    getPageVisibilityForSlug(slug) !== VISIBILITY_OPTIONS.public &&
    !loggedIn.value
  ) {
    navigateTo(buildAuthLoginUri(to.path, to.query), {
      external: true
    });
  }
  /**
   * HINT: restrictions based on basler groups from entra are handled in nuxt application (api/contentful throws 403, NuxtErrorBoundary handles this and displays the forbidden page)
   */
};

export default defineNuxtRouteMiddleware(authMiddleware);
